import React from 'react';
import { Button, ButtonsGroup, Title } from 'components/commons';
import useNavigation from 'hooks/navigation';
import { BorrowerPosition } from 'generated/graphql';
import { useAntiFraudConsumer, useApplicantHandler } from './hooks';
import vectorIcon from 'assets/svg/vector.svg';
import './bizon-not--found.styles.scss';
import { getLoanApplicationParams } from 'utils/utils';


const PartnerNotFound: React.FC = (): JSX.Element => {
    const [loading, setLoading] = React.useState(false);
    const { borrowerPosition } = useAntiFraudConsumer();
    const setAntiFraudApplicant = useApplicantHandler();
    const loanApplicationId = getLoanApplicationParams();

    const {
        goToShareAntiFraudPartner,
        goToInvalidPartner,
        goToLivenessStep,
        goToAntiFraudCheckout,
        goToError,
    } = useNavigation();

    const nextButton = async () => {
        if (borrowerPosition === BorrowerPosition.NotPartner) {
            goToInvalidPartner();
            return;
        }

        try {
            setLoading(true);
            const {
               data
            } = await setAntiFraudApplicant({
                variables: {
                    applicantInput: {
                        loanApplicationId,
                    }
                }
            });

            data?.setAntiFraudApplicantForLoanApplication.__typename === 'Applicant'
                ? goToLivenessStep()
                : goToAntiFraudCheckout();
        } catch (error) {
            setLoading(false);
            goToError();
        }
    };

    return (
        <div className="grid-container bizon-not--found">
            <Title className="bizon-not--found__title">você é o sócio/dono dessa empresa?</Title>
            <img
                className="bizon-not--found__icon" src={vectorIcon}
            />
            <h2 className="bizon-not--found__sub-title" >Por que precisamos confirmar?</h2>
            <span className="bizon-not--found__content" >Para sua análise de crédito ser válida a partir daqui pediremos dados e fotos do rosto do sócio.</span>
            <div className="bizon-not--found__footer">
                <ButtonsGroup>
                    <Button
                        className=""
                        type="button"
                        label="não"
                        disabled={loading}
                        variant="secondary"
                        onClick={goToShareAntiFraudPartner}
                    />
                    <Button
                        type="button"
                        label="sim"
                        disabled={loading}
                        loading={loading}
                        onClick={nextButton}
                    />
                </ButtonsGroup>
            </div>
        </div>
    );
};

export default PartnerNotFound;
